// extracted by css-extract-rspack-plugin
export default {"alert":"alert-lfMHv7","info":"info-OGNXZ4","success":"success-_9LB2a","warning":"warning-ZIL78T","danger":"danger-SQYSqz","icon":"icon-v1kL70","body":"body-phRTcX"};